// When we should automatically shutdown Session Replay when there's no `usage-tracker` activity
export const DEFAULT_SHUTDOWN_TIMEOUT = 1000 * 60 * 2; // 2 minutes

// The default sample rate for Session Replay is 1% of the traffic
export const DEFAULT_SAMPLE_RATE = 1; // 100% of traffic will be recorded

// The BE endpoint for retrieving Session Replay configuration
export const CONFIG_ENDPOINT_URL = '/hublytics/session-replay/v1/config';

// The BE endpoint for retrieving Session Replay tracking
export const TRACK_ENDPOINT_URL = '/usage-logging/v1/log/session-replay';
export const PLATFORM_TRACKER_CONFIG = {
  standalone: true,
  bypassPool: true,
  onScheduled: () => {},
  onError: () => {},
  onWarning: () => {},
  preserveTrackerProperties: false,
  preserveTrackerEvents: false,
  lastKnownEventProperties: []
};
export const DEFAULT_PII_SELECTORS = {
  BLOCK: [
  // For retro compatibility with Full Story we add `.fs-exclude` to the Block Selectors
  // @see https://help.fullstory.com/hc/en-us/articles/360020623574-How-do-I-protect-my-users-privacy-in-Fullstory
  '.fs-exclude'],
  MASK: [
  // Masks the global navigation (V3/V4) menu entry that contains your profile information
  // since this is a global element, we want to block it by default
  '#accounts-menu-content > li:first-child',
  // Masks the global navigation (V3/V4) switch menu button that includes your profile picture
  '#hs-global-toolbar-accounts',
  // For retro compatibility with Full Story we add `.fs-mask` to the Mask Selectors
  // @see https://help.fullstory.com/hc/en-us/articles/360020623574-How-do-I-protect-my-users-privacy-in-Fullstory
  '.fs-mask',
  // Masks the UISelect Popover Menu that contains all the options of the UISelect, effectively
  // masking all the text under the UISelect's Dropdown menus. This should work with all variants of UISelect
  '.Select-menu-outer'],
  UNMASK: [
  // For retro compatibility with Full Story we add `.fs-unmask` to the Unmask Selectors
  // @see https://help.fullstory.com/hc/en-us/articles/360020623574-How-do-I-protect-my-users-privacy-in-Fullstory
  '.fs-unmask']
};